<!-- manual-form.component.html -->
<form [formGroup]="createManualForm" novalidate>
  <!-- Title Field -->
  <div class="form-group">
    <label for="title">
      <span translate>TITLE</span>
      <span class="required">*</span>
      <!-- Tooltip for common manual origin -->
      <span
        *ngIf="manual.isCommon && manualType !== 'common'"
        pTooltip="{{ 'MANUAL_ORIGINATED_FROM_COMMON' | translate }}"
        tooltipPosition="top"
        class="icon ic-sm icon-info"
      ></span>
    </label>
    <div>
      <input
        type="text"
        formControlName="title"
        id="title"
        pInputText
        class="form-control"
      />
    </div>
    <!-- Validation Messages -->
    <control-messages
      [control]="createManualForm.controls['title']"
    ></control-messages>
  </div>

  <!-- Description Field -->
  <div class="form-group">
    <label for="description">
      <span translate>DESCRIPTION</span>
    </label>
    <div>
      <textarea
        style="width: 100%; min-height: 80px"
        pInputTextarea
        formControlName="description"
        id="description"
        class="form-control"
        [autoResize]="true"
        rows="3"
      >
      </textarea>
    </div>
    <!-- No specific validation messages shown for description in original code -->
  </div>

  <!-- Status Dropdown -->
  <div class="form-group">
    <label for="status">
      <span translate>STATUS</span>
      <span class="required">*</span>
    </label>
    <div>
      <p-dropdown
        [options]="status"
        formControlName="status"
        id="status"
        [style]="{ width: '100%' }"
        appendTo="body"
        placeholder="{{ 'SELECT_STATUS' | translate }}"
      ></p-dropdown>
    </div>
    <!-- Validation Messages -->
    <control-messages
      [control]="createManualForm.controls['status']"
    ></control-messages>
  </div>

  <!-- Business Dropdown (Conditional) -->
  <div class="form-group" *ngIf="manualType == 'business'">
    <label for="business">
      <span translate>CHOOSE_BUSINESS</span>

      <span
        class="required"
        *ngIf="
          createManualForm.get('business')?.hasValidator(Validators.required)
        "
        >*</span
      >
    </label>
    <div>
      <p-dropdown
        [options]="chooseBusiness"
        formControlName="business"
        id="business"
        [filter]="true"
        filterBy="label"
        [style]="{ width: '100%' }"
        placeholder="{{ 'SELECT_BUSINESS' | translate }}"
        appendTo="body"
      >
        <!-- Removed [disabled] logic -->
      </p-dropdown>
    </div>
    <!-- Validation Messages -->
    <control-messages
      [control]="createManualForm.controls['business']"
    ></control-messages>
  </div>

  <!-- Portal Dropdown (Conditional) -->
  <div class="form-group" *ngIf="manualType == 'portal'">
    <label for="portal">
      <span translate>CHOOSE_PORTAL</span>
      <!-- Required asterisk logic depends on whether it's new or edit -->
      <span
        class="required"
        *ngIf="
          createManualForm.get('portal')?.hasValidator(Validators.required)
        "
        >*</span
      >
    </label>
    <div>
      <p-dropdown
        [options]="choosePortal"
        formControlName="portal"
        id="portal"
        [style]="{ width: '100%' }"
        [filter]="true"
        filterBy="label"
        placeholder="{{ 'SELECT_PORTAL' | translate }}"
        appendTo="body"
      >
      </p-dropdown>
    </div>
    <!-- Validation Messages -->
    <control-messages
      [control]="createManualForm.controls['portal']"
    ></control-messages>
  </div>

  <!-- Cover Image Upload Section (Conditional) -->
  <div class="form-group" *ngIf="showUpload">
    <div class="upload-file-container">
      <label translate>COVER_IMAGE</label>
      <div class="upload-actions">
        <!-- Hidden file input -->
        <input
          #fileInput
          type="file"
          id="files"
          class="hidden-file-input"
          (change)="filesSelectForCoverImage($event)"
          accept="image/*"
        />
        <!-- Button to trigger file input -->
        <button
          type="button"
          (click)="fileInput.click()"
          class="btn btn-outline-primary"
        >
          <span translate>UPDATE_COVER_IMAGE</span>
        </button>
      </div>
      <!-- Uploading Indicator -->
      <div *ngIf="uploadStartForCoverImage" class="upload-indicator">
        <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
        <span translate>COVER_IMAGE_UPLOADING</span>
      </div>
      <!-- Image Preview -->
      <div
        *ngIf="coverImage && !uploadStartForCoverImage"
        class="image-preview mt-2"
      >
        <img
          [src]="coverImage"
          alt="{{ 'COVER_IMAGE_PREVIEW' | translate }}"
          width="100"
          height="100"
          class="thumbnail"
          style="object-fit: cover"
        />
      </div>
    </div>
  </div>
</form>
